<template>
  <div>
    <el-dialog title="补充缴费" :visible.sync="dialogVisible" width="420px" @close="handleClose" :close-on-click-modal="false">
      <el-form :model="form" :rules="rules" ref="tempFeeForm" label-width="100px">
        <el-form-item label="房屋">
          <span>{{ form.roomName }}</span>
        </el-form-item>
        <el-form-item label="收费金额" prop="amount">
          <el-input-number
            v-model="form.amount"
            :precision="2"
            :min="0.01"
            :max="999999"
            placeholder="请输入金额"
            style="width: 100%;">
          </el-input-number>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="可选，填写备注信息"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submitTempFeePay">确认收费</el-button>
      </div>
    </el-dialog>

    <el-dialog title="收费结果" :visible.sync="resultVisible" width="400px" @close="handleResultClose" :close-on-click-modal="false">
      <div style="text-align: center; padding: 20px;">
        <p>补充缴费成功，金额：{{ resultAmount }} 元</p>
      </div>
      <div slot="footer" class="dialog-footer" style="text-align: center;">
        <el-button @click="handleResultClose">返回</el-button>
        <el-button v-if="receiptId" type="primary" @click="printReceipt">打印收据</el-button>
        <el-button v-else type="info" :loading="receiptLoading" @click="queryAndPrint">查询并打印</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { tempFeePay } from '@/api/fee/tempFeePayApi'
import { getCommunityId } from '@/api/community/communityApi'
import { queryFeeReceipt, listFeePrintPages } from '@/api/fee/payFeeOrderApi'

export default {
  name: 'TempFeePay',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        roomId: '',
        roomName: '',
        amount: 0,
        remark: ''
      },
      rules: {
        amount: [
          { required: true, message: '请输入收费金额', trigger: 'blur' }
        ]
      },
      resultVisible: false,
      resultAmount: '',
      detailId: '',
      receiptId: '',
      receiptLoading: false,
      printUrl: '/#/pages/property/printPayFee'
    }
  },
  created() {
    this.loadPrintUrl()
  },
  methods: {
    open(params) {
      this.form.roomId = params.roomId
      this.form.roomName = params.roomName
      this.form.amount = 0
      this.form.remark = ''
      this.dialogVisible = true
    },
    async loadPrintUrl() {
      try {
        const communityId = getCommunityId()
        const response = await listFeePrintPages({ page: 1, row: 1, state: 'T', communityId })
        if (response.data && response.data.length > 0) {
          this.printUrl = response.data[0].url
        }
      } catch (e) {
        // ignore
      }
    },
    async submitTempFeePay() {
      if (!this.form.amount || this.form.amount <= 0) {
        this.$message.warning('请输入大于0的收费金额')
        return
      }
      try {
        await this.$refs.tempFeeForm.validate()
        this.loading = true
        const res = await tempFeePay({
          payerObjId: this.form.roomId,
          amount: this.form.amount,
          remark: this.form.remark || '补充缴费'
        })
        this.resultAmount = this.form.amount
        this.detailId = res.data ? res.data.detailId : ''
        this.receiptId = ''
        this.dialogVisible = false
        this.$emit('success')
        this.resultVisible = true
        // 自动查询收据
        this.autoQueryReceipt()
      } catch (error) {
        if (error !== false) {
          this.$message.error('补充缴费失败：' + (error.message || '未知错误'))
        }
      } finally {
        this.loading = false
      }
    },
    async autoQueryReceipt() {
      if (!this.detailId) return
      try {
        this.receiptLoading = true
        const communityId = getCommunityId()
        const response = await queryFeeReceipt({
          detailIds: this.detailId,
          communityId,
          page: 1,
          row: 1
        })
        if (response.code === 0 && response.data && response.data.length > 0) {
          this.receiptId = response.data[0].receiptId
        }
      } catch (e) {
        // ignore
      } finally {
        this.receiptLoading = false
      }
    },
    async queryAndPrint() {
      if (!this.detailId) {
        this.$message.warning('缺少缴费明细信息')
        return
      }
      try {
        this.receiptLoading = true
        const communityId = getCommunityId()
        const response = await queryFeeReceipt({
          detailIds: this.detailId,
          communityId,
          page: 1,
          row: 1
        })
        if (response.code === 0 && response.data && response.data.length > 0) {
          this.receiptId = response.data[0].receiptId
          this.printReceipt()
        } else {
          this.$message.warning('收据尚未生成，请稍后再试')
        }
      } catch (e) {
        this.$message.error('查询收据失败')
      } finally {
        this.receiptLoading = false
      }
    },
    printReceipt() {
      if (!this.receiptId) {
        this.$message.warning('收据ID不存在')
        return
      }
      window.open(`${this.printUrl}?receiptId=${this.receiptId}&merge=OFF`)
    },
    handleClose() {
      this.form = { roomId: '', roomName: '', amount: 0, remark: '' }
      if (this.$refs.tempFeeForm) {
        this.$refs.tempFeeForm.resetFields()
      }
    },
    handleResultClose() {
      this.resultVisible = false
      this.receiptId = ''
      this.detailId = ''
    }
  }
}
</script>
